import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/providers'

class ProviderApi {
  getDetail() {
    return axios
      .get(API_URL + '/_detail', { headers: authHeader() })
  }

  getStats() {
    return axios
      .get(API_URL + '/_stats', { headers: authHeader() })
  }

  updateLoyaltyText(data) {
    return axios
      .put(API_URL + '/_loyalty/_text', data, { headers: authHeader() })
  }
}

export default new ProviderApi()
